<template>
  <div class="flex items-center gap-2">
    <div
      class="h-1.5 w-16 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-600"
    >
      <div
        class="h-full rounded-full transition-all"
        :class="color"
        :style="{ width: `${clampedValue}%` }"
      />
    </div>
    <span class="whitespace-nowrap text-xs text-slate-500 dark:text-slate-400">
      {{ value }}%
    </span>
  </div>
</template>

<script>
export default {
  name: 'RateBar',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: 'bg-green-500',
    },
  },
  computed: {
    clampedValue() {
      return Math.min(Math.max(this.value || 0, 0), 100);
    },
  },
};
</script>
